import { handleDynamicFormLabels } from "./util/dynamicFormLabels";
import { Sentry } from "./sentryInstrument";

document.addEventListener("DOMContentLoaded", () => {
  handleDynamicFormLabels();
  logWhenIframed();
});

// Hover dropdown and delay for main desktop navigation
// 990 is breakpoint to show desktop nav
const dropdowns = document.querySelectorAll(".nav:not(.credits-nav) .dropdown");
const hoverIntent = new SV.HoverIntent(dropdowns, {
	onEnter: function(targetItem) {
    if (window.innerWidth >= 990) {
      targetItem.querySelector(".dropdown-menu").classList.add('show');
    }
	},
	onExit: function(targetItem) {
    if (window.innerWidth >= 990) {
      targetItem.querySelector(".dropdown-menu").classList.remove('show');
    }
	},
	exitDelay: 1000,
	interval: 100,
	sensitivity: 7,
});


const logWhenIframed = () => {
  if (window.self != window.top) {
	const message = `Being iframed from ${window.top.document.location.href}`;
	if (Sentry && Sentry.captureMessage) {
	  Sentry.captureMessage(message, "warning");
	} else {
	  throw Error(message);
	}
  }
}
